import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { bootcamps as localBootcamps } from "@/content/bootcamps";

/**
 * Single source of truth for "how many bootcamps do we sell".
 * Mirrors the catalog merge: published DB rows + content-file entries, deduped
 * by slug. Marketing copy interpolates this so the number can never drift from
 * what /catalog actually renders.
 */
export function useBootcampCount(): number {
  const [count, setCount] = useState<number>(localBootcamps.length);

  useEffect(() => {
    let alive = true;
    supabase
      .from("bootcamps")
      .select("slug")
      .eq("published", true)
      .then(({ data }) => {
        if (!alive) return;
        const slugs = new Set<string>((data ?? []).map((r) => r.slug as string));
        for (const bc of localBootcamps) slugs.add(bc.slug);
        setCount(slugs.size);
      });
    return () => {
      alive = false;
    };
  }, []);

  return count;
}
